import { HttpError } from '@forto-dev/ui-platform-http'

import { retry } from '@/utils/networking/retry'

import { getBooking } from '../api/booking'

const isBookingNotFound = (error: unknown) => error instanceof HttpError && error.status === 404

export const waitForBookingToExist = async (bookingId: string, maxAttempts = 10, delay = 500): Promise<boolean> => {
  const fetchBooking = () =>
    getBooking(bookingId, {
      // Suppress error logging: a 404 here is expected while the booking propagates.
      errorLoggingHandledUpstream: true,
    })
  try {
    await retry(fetchBooking, maxAttempts, delay, undefined, isBookingNotFound)
    return true
  } catch {
    return false
  }
}
